import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Button, Card, Tag } from "@/components/ui";
import type { InboundCallResult } from "./queries";

/**
 * What was written, said back before the next call is taken.
 *
 * Who received it comes from the server and not from the select: on an account
 * somebody holds the call goes to its holder, and that may not be who reception
 * had picked. The entry is shown as the seller will read it.
 */
export function CallRegistered({
  result,
  canOpenCompany,
  onAnother,
}: {
  result: InboundCallResult;
  /** A colleague's company answers 403 to reception; management may open any. */
  canOpenCompany: boolean;
  onAnother: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Card title={t("reception.done.title")}>
      <div className="space-y-4 p-4">
        <p role="status" className="text-lg">
          {t("reception.done.assignedTo", { agent: result.agent.name })}
        </p>

        <dl className="grid gap-x-6 gap-y-1 text-sm sm:grid-cols-2">
          <div className="flex flex-wrap items-baseline gap-2">
            <dt className="text-mute-600">{t("reception.done.company")}</dt>
            <dd>{result.company.name || result.company.legal_name}</dd>
            {result.company_created ? (
              <Tag tone="accent">{t("reception.done.newCompany")}</Tag>
            ) : null}
          </div>
          <div className="flex gap-2">
            <dt className="text-mute-600">{t("reception.done.contact")}</dt>
            <dd>{result.contact.name}</dd>
          </div>
        </dl>

        <p className="border-2 border-rule bg-panel px-3 py-2 text-sm">
          {result.activity.comment}
        </p>

        <div className="flex flex-wrap items-center gap-3">
          <Button variant="primary" data-autofocus="" onClick={onAnother}>
            {t("reception.done.another")}
          </Button>
          <Link to="/recepcion" className="btn btn-secondary">
            {t("reception.backToList")}
          </Link>
          {canOpenCompany ? (
            <Link className="text-sm underline" to={`/prospectos/${result.company.id}`}>
              {t("leads.openCompany")}
            </Link>
          ) : null}
        </div>
      </div>
    </Card>
  );
}
